import createModel, { arbitraryKeys } from "@/__main__/data-model.mjs";

const apiModelValidation = createModel({
  [arbitraryKeys]: {
    name: String,
    description: String,
    leveling: {
      [arbitraryKeys]: [String],
    },
  },
});

function transform(data) {
  return apiModelValidation(data);
}

export default transform;
